import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from '../containers/Home'

export default function routes() {
  return (
      <Routes>
        <Route path="/integrations/bullhorn" element={<Home />} />
      </Routes>
  )
}

